module.exports = __webpack_public_path__ + "881ba06f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/icon_ser_14ftlorry@2x.png
// module id = 1143
// module chunks = 0